import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const PalmTreeIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M1 2.416C1.90415 0.946683 4.1182 0.557873 5.94523 1.54757C7.01067 2.12471 7.78206 3.04318 8 4L7.99903 3.99574C8.21697 3.03892 8.98934 2.12471 10.0548 1.54757C11.8818 0.557873 14.0959 0.946683 15 2.416L10.0004 5.12428C12.8917 5.49314 15 6.64105 15 8H10.1435C9.83683 8 9.60341 8.2737 9.63071 8.57919C9.75262 9.94349 9.56191 11.3231 9.06653 12.6111L8.27099 14.6795C8.19672 14.8726 8.0112 15 7.80431 15H6.7329C6.38201 15 6.14026 14.648 6.26623 14.3205L7.19984 11.8931C7.62801 10.7799 7.76354 9.57867 7.59795 8.40356C7.56472 8.16775 7.35768 8 7.11955 8H1C1 6.64105 3.10833 5.49314 5.99964 5.12428L1 2.416Z"
		></path>
	</svg>
))
